import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/304'

const AverageOrdersPerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.average_orders_per_location_per_month"
  />
)

export default AverageOrdersPerLocationPerMonthTab
